export enum Trading_Version {
  Game = '1.0.1',
  RNG = '1.0.0',
}
